<div item-detail class="app-list-item-detail">
  <ng-content></ng-content>
</div>
